<main>
  <!-- Hero Section -->
  <section
    class="bg-[url('/assets/images/Group_78.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5"
  >
    <div
      class="container flex flex-col justify-center items-center text-center"
    >
      <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
        Driven by Passion for Sustainable Mobility
      </h1>
      <p class="text-white font-semibold text-center text-lg lg:text-xl">
        Discover how Only Used Tesla revolutionized the pre-owned Tesla market.
      </p>
    </div>
  </section>

  <!-- Mission -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          Our Mission: Redefining Tesla Ownership
        </h2>
        <p>
          At Only Used Tesla, we've pioneered the first marketplace exclusively
          designed for buying and selling pre-owned Tesla vehicles. These aren't
          just ordinary cars; Tesla vehicles redefine luxury, marrying advanced
          technology with sustainable travel. We recognize that factors like
          restrictive dealership practices, hefty price tags of new-age
          technology, or an insufficient supply due to soaring demand can deter
          potential owners. That's why our platform breaks down barriers,
          creating an accessible marketplace for those looking to sell their
          Tesla or find a used Tesla for sale. We uniquely facilitate seamless
          transactions between Tesla enthusiasts and prospective owners,
          eliminating the challenges traditionally associated with acquiring
          these innovative machines.
        </p>
      </div>
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/Group_69.webp"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
    </div>
  </section>

  <!-- Why Choose Us -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16 bg-gray-50">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/tesla-1.webp"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
      <!-- Text -->
      <div class="lg:basis-[50%]">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          Why Only Used Tesla?
        </h2>
        <p>
          As a dedicated platform for Tesla resales, we proudly stand as one of
          the rare, if not the only, venues focused on offering used Teslas. Our
          mission revolves around making pre-owned Teslas more accessible to
          enthusiasts and aspiring owners alike. If you're scouring the market
          for a used Tesla for sale from a private seller or dealer, your search
          ends here at Only Used Tesla. We provide a focused and trusted
          environment for Tesla transactions.
        </p>
      </div>
    </div>
  </section>

  <!-- Sell My Tesla -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row items-center justify-center gap-5 lg:gap-10"
    >
      <!-- Text -->
      <div class="lg:basis-[50%] flex flex-col gap-3">
        <h2 class="text-3xl lg:text-4xl font-bold">
          Selling Your Tesla Made Simple
        </h2>
        <p>
          Planning to sell your Tesla? We provide an efficient and effective
          platform, ensuring your vehicle finds a new home with someone who will
          appreciate it just as much as you have. Our streamlined process
          removes the typical hassles of private sales, allowing you to connect
          with serious buyers quickly and easily.
        </p>
        <button
          [routerLink]="
            (auth.isAuthenticated$ | async) ? '/your-tesla' : '/sell-my-tesla'
          "
          class="w-fit text-OUT-Blue border-2 !border-OUT-Blue rounded-full px-4 py-1.5 font-semibold hover:bg-OUT-Blue hover:text-white transition-colors duration-400 cursor-pointer"
        >
          Sell Your Tesla
        </button>
      </div>
      <!-- Image -->
      <div class="relative lg:basis-[50%] rounded-lg overflow-hidden">
        <img
          src="/assets/images/ModelX_68.webp"
          alt="hero_image"
          class="h-full w-full object-cover"
        />
      </div>
    </div>
  </section>

  <!-- Meet The Founder -->
  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 xl:py-16 py-5 bg-gray-50">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-start gap-5 lg:gap-10"
    >
      <!-- Image -->
      <div class="relative lg:basis-[40%] overflow-hidden">
        <img
          src="/assets/images/adam.jpg"
          alt="Adam Qureshi"
          class="h-full w-[80%] object-cover rounded-lg"
        />
      </div>
      <!-- Text -->
      <div class="lg:basis-[50%] space-y-2">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          Meet the Founder: Adam Qureshi
        </h2>
        <p>
          Adam Qureshi's journey began humbly on the streets of New York, where
          he delivered newspapers and sold luxury bags to the wealthy elite.
          Through hard work and uncompromisingly honest business practices, he
          built his life and company. Today, Adam is devoted to helping existing
          and prospective Tesla owners with great deals and services. His firm
          stance on fraud protection and robust universal digital privacy rights
          has earned him immense respect within the Tesla community. Moving
          forward, his calling is to help wean the world off its gasoline
          addiction and help everyone make the switch to electric vehicles so
          that the future is a cleaner, brighter, and healthier place for us
          all.
        </p>
        <div class="mb-4 mt-5">
          <a
            href="https://www.linkedin.com/in/adamqureshi/"
            target="_blank"
            class="text-OUT-Blue border-2 !border-OUT-Blue rounded-full px-4 py-2 mt-5 font-semibold hover:bg-OUT-Blue hover:text-white transition-colors duration-400"
          >
            Connect With Adam On LinkedIn
          </a>
        </div>
      </div>
    </div>
  </section>
</main>
